import React from 'react';
import PropTypes from "prop-types";
import { stepShowHide } from '../../../utilities/form/formUtils';
import Label from '../../Form/Label';

export const CombinedTaxLabel = (props) => {
  const { label, showHide, userData, hidden, taxAmount, taxPercentage } = props;
  const { totalPrice, indboInsurance, rejseInsurance, personInsurance, combinedPrice } = userData;
  const showHideresult = stepShowHide(hidden, showHide, userData);
  const unit = "$[units.$[paymentFrequency]]";
  let displayLabel = label;
  if (taxAmount) {
    let noOfInsurance = 0;
    if (indboInsurance) {
      noOfInsurance += 1;
    }
    if (rejseInsurance) {
      noOfInsurance += 1;
    }
    if (personInsurance) {
      noOfInsurance += 1;
    }

    let taxvalue = ((taxAmount * noOfInsurance).toFixed(2)).replace(".",",");
    if(combinedPrice){
      taxvalue = taxAmount.toString().replace(".",",");
    }
    displayLabel = `${label} ${taxvalue} ${unit}`;
  }
  if (taxPercentage) {
    const amount = (((totalPrice * taxPercentage) / 100).toFixed(2)).replace(".",",");
    displayLabel = `${label} ${amount} ${unit}`;
  }

  return (
    <div>
      {!showHideresult &&
        <Label label={displayLabel} />
      }
    </div>
  );
}

CombinedTaxLabel.propTypes = {
  userData: PropTypes.object.isRequired
}